var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.count))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }